import { GetRowKey, ExpandableConfig } from './baseTable/interface';
import { tuple } from '../_util/type';
// import {TableAction} from './Table';
export { GetRowKey, ExpandableConfig };
const TableActions = tuple('paginate', 'sort', 'filter');
